import styled from "@emotion/styled";

const Title = styled.h3`
  margin: 0;
  font-size: 21px;
  max-width: 460px;
  @media screen and (min-width: 768px) {
    margin: 72px 0 0 0;
  }
`;

export default Title;
